<template>
  <div>
    <vetster-inquiry-timeslot-step
      v-if="showTimeslotStep"
      class="h-full"
      @submit="(timeslots) => submitAppointmentRequest(timeslots)"
      @cancel="$emit('cancel')"
    />
    <div
      v-else
      class="flex flex-col text-center h-full"
    >
      <div class="flex justify-center items-center mt-24 lg:mt-0">
        <img
          :src="getAssetUrl('images/quote-calendar.svg')"
          :alt="$t('quote.calendar-without-available-times')"
          class="w-64 h-32 object-contain"
        />
      </div>
      <div class="flex-1 space-y-4 mt-8 px-4">
        <p class="font-title text-xl/6 font-bold text-center text-neutral-700">
          {{ skipsTimeslots ? $t('quote.request-confirmation') : $t('quote.choose-your-preferred-times') }}
        </p>
        <p class="text-center text-neutral-700">
          {{ skipsTimeslots
            ? $t('quote.by-clicking-confirm', { name: partner.fullNameWithTitle() })
            : $t('quote.select-a-few-times', { name: partner.formalName() })
          }}
        </p>
      </div>
      <div class="mt-auto lg:mt-8">
        <vetster-button
          :is-loading="loading"
          variant="bubblegum"
          class="w-full"
          @click="handleNext"
        >
          <span>
            {{ skipsTimeslots ? $t('app.confirm') : $t('quote.select-times') }}
          </span>
        </vetster-button>
        <vetster-button
          :is-loading="loading"
          variant="textLink"
          class="w-full flex justify-center underline text-sm pb-0"
          @click="$emit('cancel')"
        >
          <span>{{ $t('app.cancel') }}</span>
        </vetster-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import VetsterInquiryTimeslotStep from '@/brand-components/VetsterInquiryTimeslotStep';
import { getAssetUrl } from '@/helpers/url';
import ParseErrors from '@/mixins/ParseErrors';
import User from '@/models/User';

export default {
  name: 'VetsterRequestToBook',

  components: { VetsterInquiryTimeslotStep },

  mixins: [ParseErrors],

  props: {
    date: {
      type: [Object, String],
      default: undefined,
    },
    loading: {
      type: Boolean,
    },
    mode: {
      type: String,
      default: 'request',
    },
    partner: {
      type: User,
      required: true,
    },
    registerGuests: {
      type: Function,
      default: () => ({}),
    },
    successLogoPath: {
      type: String,
      default: '/images/vetster-phone-vet.svg',
    },
  },

  data() {
    return {
      showTimeslotStep: false,
    };
  },

  computed: {
    ...mapGetters('quote', ['getVcprLocation']),

    skipsTimeslots() {
      return this.mode === 'request';
    },
  },

  async mounted() {
    try {
      await this.fetchVcprLocation();
    } catch (e) {
      //
    }
  },

  methods: {
    ...mapActions('quote', ['fetchVcprLocation']),

    getAssetUrl,

    handleNext() {
      setTimeout(() => {
        if (this.skipsTimeslots) {
          this.$analytics.track({
            eventName: 'rtb_confirm_click',
            userId: this.$store.state.user?.uuid || null,
            parent: 'partner-page',
            child: 'select-booking',
          });
          this.submitAppointmentRequest();
        } else {
          this.showTimeslotStep = true;
        }
      }, 200);
    },

    async submitAppointmentRequest(timeslots = null) {
      if (!(await this.registerGuests())) {
        return;
      }

      try {
        this.$emit('isLoading', true);
        const response = await this.$api.post(`v1/cx/appointments/inquiry/${this.partner.uuid}`, {
          target_country: this.getVcprLocation.country,
          target_province: this.getVcprLocation.province,
          platform: 'WEB',
          start_on: this.date,
          timeslots,
        });
        this.$store.commit('quote/setAppointmentInquiry', response.data.data);
        this.$emit('isRequested', true);
      } catch (e) {
        this.parseError(e, true);
      } finally {
        this.$emit('isLoading', true);
      }
    },
  },
};
</script>
